module.exports = __webpack_public_path__ + "img/irrigation-control-3.3bb9c5c8.jpg";